@if (loading()) {
  <section id="loader-skeleton">
    <div class="menu-skeleton">
      <p-skeleton animation="wave" height="100%" width="100%"></p-skeleton>
    </div>
    <div class="content-skeleton">
      <p-skeleton animation="wave" height="100%" width="100%"></p-skeleton>
    </div>
  </section>
}

<router-outlet></router-outlet>
<app-update-notif-host></app-update-notif-host>
